import DefaultLayout from "./layout/default-layout/index";
import PageLayout from "./layout/page-layout/index";
import ErrorPage from "./views/system/error-page/index";
import UnderDevelopment from "./views/system/under-development/index";

export { DefaultLayout, PageLayout, ErrorPage, UnderDevelopment };
/**
 * 系统页面
 */
import { ApiLog } from "./views/system/api-log/index";

export { ApiLog };

import { AreaManage } from "./views/system/area/index";

export { AreaManage };

import {
  UserManage,
  UserEdit,
  UserDetail,
  UserRole,
  UserMenu
} from "./views/system/user/index";

export { UserManage, UserEdit, UserDetail, UserRole, UserMenu };

import { UnitManage, UnitEdit, UnitDetail } from "./views/system/unit/index";

export { UnitManage, UnitEdit, UnitDetail };

import {
  MenuManage,
  MenuEdit,
  MenuDetail,
  MenuBtn,
  MenuBtnEdit
} from "./views/system/menu/index";

export { MenuManage, MenuEdit, MenuDetail, MenuBtn, MenuBtnEdit };

import {
  RoleManage,
  RoleEdit,
  RoleUser,
  RoleMenu
} from "./views/system/role/index";

export { RoleManage, RoleEdit, RoleUser, RoleMenu };

import { QuartzManage, QuartzEdit } from "./views/system/quartz/index";

export { QuartzManage, QuartzEdit };

import {
  CodeManage,
  SimpleCode,
  SimpleCodeEdit
} from "./views/system/code/index";

export { CodeManage, SimpleCode, SimpleCodeEdit };

import {
  CodeRule
} from "./views/system/code-rule/index";

export { CodeRule };


import { ParamManage, ParamEdit } from "./views/system/param/index";

export { ParamManage, ParamEdit };

/**
 * 组件
 */

import BaseHeadline from "./components/layout/headline/index";
import LeafletTitle from "./components/layout/title/leaflet/index";
import FixedFooter from "./components/layout/fixed-footer/index";
import PageFrame from "./components/layout/page-frame/index";
import BaseContainer from "./components/layout/base-container/index";
import ZwxScreen from "./components/layout/screen/index";

const COMPONENT_LAYOUT = [
  BaseHeadline,
  PageFrame,
  BaseContainer,
  LeafletTitle,
  FixedFooter,
  ZwxScreen
];

import FilePreview from "./components/data-display/preview/index";
import BaseTab from "./components/data-display/base-tab/index";

const COMPONENT_DATA_DISPLAY = [FilePreview, BaseTab];

import DataImport from "./components/data-input/data-import/index";
import ImportDialog from "./components/data-input/import-dialog/index";
import FileUpload from "./components/data-input/file-upload/index";
import FileUploadMultiple from "./components/data-input/file-upload-multiple/Index";
import FileUploadDialog from "./components/data-input/file-upload-dialog/Index";
import AmountInput from "./components/data-input/input/amout/index";
import CodeRadio from "./components/data-input/radio/index";
import CodeSelect from "./components/data-input/select/code-select/index";
import TreeSelect from "./components/data-input/select/tree-select/index.js";
import BtnSelect from "./components/data-input/select/btn-select/index.js";
import CodeMultiple from "./components/data-input/select/code-multiple/index";
import CustomMultiple from "./components/data-input/select/custom-multiple/index";
import CascaderOptionsMulti from "./components/data-input/cascader/cascader-options-multi/index";
import CascaderOptionsSingle from "./components/data-input/cascader/cascader-options-single/index";
import CascaderSingle from "./components/data-input/cascader/cascader-single/index";

const COMPONENT_DATA_INPUT = [
  DataImport,
  ImportDialog,
  FileUpload,
  FileUploadMultiple,
  FileUploadDialog,
  AmountInput,
  CodeRadio,
  CodeSelect,
  TreeSelect,
  BtnSelect,
  CodeMultiple,
  CustomMultiple,
  CascaderOptionsMulti,
  CascaderOptionsSingle,
  CascaderSingle
];

import BaseDialog from "./components/feedback/base-dialog/index";
import StepDialog from "./components/feedback/step-dialog/index";
import TipsDialog from "./components/feedback/tips-dialog/index";

const COMPONENT_FEEDBACK = [BaseDialog, StepDialog, TipsDialog];

import BasePagination from "./components/navigation/base-pagination/index";
import PageHeader from "./components/navigation/page-header/index";
import SideMenu from "./components/navigation/side-menu/index";

const COMPONENT_NAVIGATION = [BasePagination, PageHeader, SideMenu];

import ZwxScrollbarX from "./components/other/scrollbar/horizontal/index";
import ZwxScrollbarY from "./components/other/scrollbar/vertical/index";
import SkinTheme from "./components/other/skin/theme/index";
import ZwxVerifyCode from "./components/other/verify/code/index";
import QrCode from "./components/other/qr/code/index";
import ZwxKv from "./components/other/kv/index";
import SmallTips from "./components/other/smallTips/index";
import ZwxSign from "./components/other/sign/index.js";

const COMPONENT_OTHER = [
  ZwxScrollbarX,
  ZwxScrollbarY,
  SkinTheme,
  ZwxVerifyCode,
  QrCode,
  ZwxKv,
  SmallTips,
  ZwxSign
];

import ZwxSelectArea from "./components/widgets/area/index";
import IndustrySelect from "./components/widgets/industry/index";
import OfficialAccount from "./components/widgets/official-account/index";
import UnitSelect from "./components/widgets/unit-select/index";
import PasswordModify from "./components/widgets/password-modify/index";
import BaiduMapDialog from "./components/widgets/baidu-map-dialog/index";
import HazardSelectDialog from "./components/widgets/hazard-select-dialog/index";
import HazardDropDown from "./components/widgets/hazard-drop-down/index";

const COMPONENT_WIDGET = [
  ZwxSelectArea,
  IndustrySelect,
  OfficialAccount,
  BaiduMapDialog,
  PasswordModify,
  UnitSelect,
  HazardSelectDialog,
  HazardDropDown
];

import ZwxIpc from "./components/other/ipc/index";

const COMPONENT = []
  .concat(COMPONENT_LAYOUT)
  .concat(COMPONENT_DATA_INPUT)
  .concat(COMPONENT_DATA_DISPLAY)
  .concat(COMPONENT_FEEDBACK)
  .concat(COMPONENT_NAVIGATION)
  .concat(COMPONENT_OTHER)
  .concat(ZwxIpc)
  .concat(COMPONENT_WIDGET);

import System from "./utils/system";
import Validate from "./utils/validate";
import ZwxBase from "./utils/base";
import ZwxCookie from "./utils/cookie";
import ZwxLocalStorage from "./utils/local-storage";
import ZwxJsStore from "./utils/jsstore";
import ZwxSm from "./utils/sm";
import ZwxSkin from "./utils/skin";
import SimpleCodeTools from "./utils/simple-code-tools";

export {
  System,
  Validate,
  ZwxBase,
  ZwxCookie,
  ZwxLocalStorage,
  ZwxJsStore,
  ZwxSm,
  ZwxSkin,
  SimpleCodeTools
};

const install = function(Vue) {
  if (install.installed) return;
  install.installed = true;
  COMPONENT.map(component => {
    Vue.component(component.name, component);
  });
  Vue.prototype.$system = System;
  Vue.prototype.$validate = Validate;
  Vue.prototype.$zwxBase = ZwxBase;
  Vue.prototype.$zwxCookie = ZwxCookie;
  Vue.prototype.$zwxLocalStorage = ZwxLocalStorage;
  Vue.prototype.$zwxJsStore = ZwxJsStore;
  Vue.prototype.$zwxSm = ZwxSm;
  Vue.prototype.$zwxSkin = ZwxSkin;
  Vue.prototype.$simpleCodeTools = SimpleCodeTools;

  const inputMaxlengthLimit = Vue.prototype.$zwxBase.inserted;
  Vue.directive("inputMaxlengthLimit", {
    inserted: inputMaxlengthLimit
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ...COMPONENT
};
